import { auth, db, firestore, emailAuthProvider } from '../../plugins/firebase'
import router from '../../router'

const state = {
    profile: null,
    logged: false,
    view: 'Plant',
    collection: null
}

const getters = {
    getProfile: state => state.profile,
    getRates: state => state.profile.rates
}

const actions = {
    checkLogin({ state, commit, dispatch }){
        return new Promise(async (resolve, reject) => {
            if(auth.currentUser){
                let user = auth.currentUser
                if(!state.collection) commit('UPDATE_COLLECTION', user.uid)
                let userData = await state.collection.get()
                
                if(!userData.exists){
                    await dispatch('logout')
                    router.push({ name: 'Login' })
                    return
                }

                await dispatch('setUserProfile', { ...userData.data(), email: user.email })
                commit('UPDATE_LOGIN', true)
                resolve({
                    id: userData.data().account,
                    level: userData.data().level,
                    user: user.uid
                })

            }else{
                await dispatch('setUserProfile', {})
                commit('UPDATE_COLLECTION')
                commit('UPDATE_LOGIN', false)
                resolve(null)
            }
                
        })
    },
    login({ state, commit }, credentials){
        return new Promise(async (resolve, reject) => {
            if(state.logged) return resolve({ message: 'Ya esta logueado' })
            try {
                let { user } = await auth.signInWithEmailAndPassword(credentials.email, credentials.password)
                return resolve({ message: 'Login exitoso' })
            } catch (error) {
                return reject({ message: 'Revisa los datos' })
            }
            
           
        })
    },
    updatePassword({ commit }, payload){
        const { old_pass, new_pass } = payload
        
        return new Promise(async (resolve, reject) =>{
            try {
                const user = auth.currentUser
                const credential = emailAuthProvider.credential(auth.currentUser.email, old_pass)

                let checkpass = await user.reauthenticateWithCredential(credential)
                if(!checkpass.user) return reject({ message: 'Error al realizar el cambio' })

                await user.updatePassword(new_pass)

                return resolve()
            } catch (error) {
                console.log(error)
                if(error.code === 'auth/wrong-password')
                    return reject({ message: 'Antigua contraseña incorrecta' })
                else
                    return reject({ message: error.message })
            }
        })
    },
    updatedView({ state, commit }, view) {
        if(state.view != view) 
            commit('UPDATE_VIEW', view)

        return
    },
    async setUserProfile({ commit }, user){
        if(!user) return
        commit('SET_PROFILE', user)
    },
    logout(){
        return new Promise(async (resolve, reject) =>{
            try {
                if(!auth.currentUser) return resolve({ message: 'Sin sesion' })
                await auth.signOut()
                return resolve({ message: 'Sesión terminada' })
            } catch (error) {
                return reject({ message: 'Error al cerrar sesión' })
            }
        })
    }
}

const mutations = {
    UPDATE_LOGIN(state, value){
        state.logged = value
    },
    UPDATE_VIEW(state, value){
        state.view = value
    },
    SET_PROFILE(state, value){
        state.profile = value
    },
    UPDATE_COLLECTION(state, path){
        path 
            ? state.collection = db.doc(`users_solar/${path}`)
            : state.collection = null
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
